window.Products.Bag.OrigamiTote = function() {};
window.Products.Bag.OrigamiTote.inherits(window.Products.Bag.Bag);

window.Products.Bag.OrigamiTote.id = 67;
window.Products.Bag.OrigamiTote.slug = 'origami-tote';
window.Products.Bag.OrigamiTote.has_3d = true;
window.Products.Bag.OrigamiTote.dpi = 150;

window.Products.Bag.OrigamiTote.prototype.set3dProperties = function(modelViewer) {
	this.updateThreeTexture(modelViewer);
	modelViewer.object.position.y = -0.16;
};

window.Products.Bag.OrigamiTote.prototype.setThreeControls = function(controls) {
    controls.minDistance = 2.3;
    controls.maxDistance = 3.4;
};

window.Products.Bag.OrigamiTote.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[1].material.map = modelViewer.texture;
    modelViewer.object.children[2].material.map = modelViewer.texture;
};